<template>
	<div>
		<router-view></router-view>
	</div>
</template>

<script>
export default {
	name: '',
	data() {
		return {
			footerShow: true,
			isWhite: true,
			isBlack: false,
			navModal: false,
			options: {
				licenseKey: "OPEN-SOURCE-GPLV3-LICENSE",
				beforeLoad: this.afterLoad,
				afterLoad: this.afterLoad,
				scrollOverflow: true,
				scrollBar: false,
				menu: "#menu",
				// navigation: true,
				// anchors: ['page1', 'page2', 'page3'],
				sectionsColor: [
					"#fbfbfd",
					"#fff",
					"#000",
					"#fec401",
					"#000",
					"#fbfbfd",
					"#000",
					"#fbfbfd"
				]
			}
		}
	},
	created() {
		var reg = /^(127.0.0.1)/;
		if (window.location.hostname !== 'localhost' && !reg.test(window.location.hostname)) {
			// 判断非本地server时 http强制转换成https
			var targetProtocol = "https:";
			if (window.location.protocol != targetProtocol)
				window.location.href = targetProtocol +
					window.location.href.substring(window.location.protocol.length);
		}
	},
	methods: {
		// 导航展示
		navShow() {
			this.navModal = true;
		},
		// 关闭导航模块
		closeNavModal() {
			this.navModal = false;
		},
		// 翻页方法
		moveSectionDown() {
			this.$refs.fullpage.api.moveSectionDown();
		},
		// 翻页回调方法
		afterLoad: function (origin, destination) {
			//origin:翻页前参数/destination翻页后参数
			this.screenMethod(destination.index)
		},
		// 滚动屏数处理方法
		screenMethod(index) {
			if (index === 0 || index === 2 || index === 4 || index === 6) {
				this.isWhite = true;
				this.isBlack = false;
			}
			if (index === 1 || index === 3 || index === 5 || index === 7) {
				this.isWhite = false;
				this.isBlack = true;
			}
		},
		// 关闭浮层
		hideFooter() {
			this.footerShow = false;
		}
	}
}
</script>
<style>
</style>
